import { DiagnosticId } from '@/diagnostic/domain/DiagnosticId.ts';
import { z } from 'zod';

const diagnosticIdSchema = z.object({
  id: z.string(),
});

export type CleanApiDiagnosticIdJson = z.infer<typeof diagnosticIdSchema>;

const jsonToDiagnosticId = (json: CleanApiDiagnosticIdJson): DiagnosticId =>
  DiagnosticId.of(json.id);

export const parseJsonToDiagnosticId = (json: unknown): DiagnosticId =>
  jsonToDiagnosticId(diagnosticIdSchema.parse(json));
